Vue.component("price-item", {
  template: document.querySelector("script[data-price-item-template]")
    .innerHTML,
  props: {
    label: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      open: false,
      selected: [],
      values: [],
    };
  },
  computed: {},
  methods: {
    countProductsInRange(amount) {
      const { items = [] } = this.$parent;

      if (amount === "All") return 0;

      const [min, max = 99999999999999] = amount
        .replace(/(\$|\+)/g, "")
        .split("-")
        .map((amt) => Number(amt.trim()) * 100);

      const count = items.reduce((count, item) => {
        const isBetweenMinAndMax = min < item.price && item.price < max;

        return (count += isBetweenMinAndMax ? 1 : 0);
      }, 0);

      return count;
    },
    closeOpen() {
      this.open = false;
    },
    toggleOpen() {
      this.open = !this.open;
    },
    onChange(event) {
      const [min, max] = event.target.value.split("-");
      // console.log('Price Item Change', this.selected, event.target.value, { min, max }, this.selected);

      this.selected = [event.target.value];

      if (min === "All") {
        this.$emit("filter-change", {
          value: null,
        });
        return;
      }

      if (!max) {
        this.$emit("filter-change", {
          value: {
            min: min.trim(),
            max: -1,
          },
        });

        return;
      }

      this.$emit("filter-change", {
        value: {
          min: min.trim(),
          max: max.trim(),
        },
      });
    },
  },
  mounted() {
    this.values = [
      "All",
      "$0 - $500",
      "$500 - $1000",
      "$1000 - $2000",
      "$2000 - $5000",
      "$5000+",
    ];

    this.selected = [this.values[0]];

    window.addEventListener("scroll", () => (this.open = false));

    this.$parent.$on("clear-filters", () => {
      this.selected = [this.values[0]];
    });
  },
});

Vue.component("native-price-filter", {
  template: document.querySelector("script[data-native-price-item-template]")
    .innerHTML,
  props: {
    label: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    max: {
      type: String,
      required: true,
    },
    min: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      open: false,
      selected: [],
      values: [],
    };
  },
  computed: {
    minValue() {
      const [value] = this.selected;

      if (!value) return 0;
      const [min, max] = value.split("-");

      if (min === "All") {
        return 0;
      }

      return min.replace("$", "").trim();
    },
    maxValue() {
      const [value] = this.selected;
      if (!value) return 9999999;

      const [min, max] = value.split("-");

      if (!max) return 9999999;

      return max.replace("$", "").trim();
    },
  },
  watch: {
    selected() {},
    minValue() {
      this.triggerFormInput();
    },
    maxValue() {
      this.triggerFormInput();
    },
  },
  methods: {
    triggerFormInput() {
      const { form } = this.$parent.$refs;

      // if (form) form.dispatchEvent(new CustomEvent("input"));
    },
    countProductsInRange(amount) {
      const { items = [] } = this.$parent;

      if (amount === "All") return 0;

      const [min, max = 99999999999999] = amount
        .replace(/(\$|\+)/g, "")
        .split("-")
        .map((amt) => Number(amt.trim()) * 100);

      const count = items.reduce((count, item) => {
        const isBetweenMinAndMax = min < item.price && item.price < max;

        return (count += isBetweenMinAndMax ? 1 : 0);
      }, 0);

      return count;
    },
    closeOpen() {
      this.open = false;
    },
    toggleOpen() {
      this.open = !this.open;
    },
    onChange(event) {
      this.selected = [event.target.value];
    },
  },
  mounted() {
    this.values = [
      "All",
      "$0 - $500",
      "$500 - $1000",
      "$1000 - $2000",
      "$2000 - $5000",
      "$5000+",
    ];

    this.selected = [this.values[0]];

    window.addEventListener("scroll", () => (this.open = false));

    this.$parent.$on("clear-filters", () => {
      this.selected = [this.values[0]];
    });
  },
});
